import { FILE_SIZE_LIMITS } from './const';
export function getMaxSizeForModel(modelId) {
    if (modelId === 'claude-sonnet-4-5@20250929') {
        return FILE_SIZE_LIMITS.LLM.ANTHROPIC_SONNET;
    }
    return FILE_SIZE_LIMITS.LLM.DEFAULT;
}
export function isVideoMimeType(mimeType) {
    return typeof mimeType === 'string' && mimeType.startsWith('video/');
}
export function calculateTotalFileSize(files) {
    return files.reduce((total, file) => total + (file.metadata.size ?? 0), 0);
}
/**
 * Validates total attachment size. Video files are checked against the dedicated
 * video limit, while all other files share the per-model inline limit.
 */
export function isWithinLimit(files, modelId) {
    const videoFiles = files.filter((file) => isVideoMimeType(file.mimeType));
    const otherFiles = files.filter((file) => !isVideoMimeType(file.mimeType));
    const videoSize = calculateTotalFileSize(videoFiles);
    const otherSize = calculateTotalFileSize(otherFiles);
    const totalSize = videoSize + otherSize;
    const videoMax = FILE_SIZE_LIMITS.LLM.VIDEO;
    const otherMax = getMaxSizeForModel(modelId);
    if (videoSize > videoMax) {
        return {
            isValid: false,
            totalSize,
            maxAllowed: videoMax,
            message: `Total video size (${formatSize(videoSize)}) exceeds limit (${formatSize(videoMax)})`,
        };
    }
    if (otherSize > otherMax) {
        return {
            isValid: false,
            totalSize,
            maxAllowed: otherMax,
            message: `Total file size (${formatSize(otherSize)}) exceeds limit (${formatSize(otherMax)})`,
        };
    }
    return {
        isValid: true,
        totalSize,
        maxAllowed: otherMax,
    };
}
export function formatSize(bytes) {
    const mb = bytes / (1024 * 1024);
    return `${mb.toFixed(1)} MB`;
}
